module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/iconfont/MaterialIcons-Regular.woff2
// module id = ../../../../../src/fonts/iconfont/MaterialIcons-Regular.woff2
// module chunks = 3